<ng-container [ngSwitch]="step$ | async">
  <app-pd-business-data
    *ngSwitchCase="steps.BusinessData"
    [data]="cs.businessData$ | async"
    [showBackButton]="initialBackButton"
    (next)="cs.submitBusinessData($event)"
    (back)="cs.prevStep()"
  >
  </app-pd-business-data>
  <app-pd-bank-data
    *ngSwitchCase="steps.BankData"
    (next)="cs.submitBankData($event)"
    (back)="cs.prevStep()"
    [data]="cs.bankData$ | async"
  ></app-pd-bank-data>
  <app-pd-documents
    *ngSwitchCase="steps.Documents"
    [visibility]="$any(cs.filesVisibility$ | async)"
    (next)="cs.submitDocuments($event)"
    (back)="cs.prevStep()"
  ></app-pd-documents>
  <app-pd-success *ngSwitchCase="steps.Success" [showProceedButton]="showProceedButton" (next)="cs.proceed()"></app-pd-success>
</ng-container>
